
<mat-menu #childMenu="matMenu" [overlapTrigger]="false" class="fg-top-nave-menu-item"
  [hasBackdrop]="localConfig?.navigationSchema?.hoverMenuEnabled ? false : true ">
  @for (child of items; track dataService.getTrackByIndex(colIndex, child); let colIndex = $index) {
    <span class="menuItems">
      @if (child.children && child.children.length > 0) {
        <span>
          @if (!topNavSettings.showMatMenuAsLink) {
            <button mat-menu-item color="primary"
              [matMenuTriggerFor]="menu.childMenu" (click)="toggleActive(menu,null)">
              @if (child.icon) {
                <span>
                  <span [class]="child.icon"></span>
                </span>
                } &nbsp;
                <span>{{child.name}}</span>
              </button>
            }
            @if (topNavSettings.showMatMenuAsLink) {
              <a mat-menu-item [routerLink]="getNamedPageUrl(menu,null)" class="">
                @if (child.icon) {
                  <span>
                    <span class="fa-stack">
                      <span [class]="child.icon" style="margin-left: 10px;"></span>
                    </span>
                  </span>
                }
                &nbsp;
                <span>{{child.name}}</span>
              </a>
            }
            <app-top-nav-menu-item #menu [items]="child.children"></app-top-nav-menu-item>
            @if (!child.hideDivider) {
              <mat-divider></mat-divider>
            }
          </span>
        }
        @if (!child.children || child.children.length === 0) {
          <span>
            @if (!topNavSettings.showMatMenuAsLink) {
              <button mat-menu-item [routerLink]="child.route"
                (click)="toggleActive(child,i)" [ngClass]="isActiveMenu(child.pageId,child) ? 'active-top-menu-sub-item' : '' ">
                <span class="menu-label">
                  <span class="menu-text">{{ child.name }}  </span>
                  @if (isActiveMenu(child.pageId,child)) {
                    <mat-icon class="tick-icon">check</mat-icon>
                  }
                </span>
              </button>
            }
            @if (topNavSettings.showMatMenuAsLink) {
              <a mat-menu-item [routerLink]="getNamedPageUrl(child,i)" class="">
                @if (child.icon) {
                  <span>
                    <span class="fa-stack">
                      <span [class]="child.icon" style="margin-left: 10px;"></span>
                    </span>
                  </span>
                }
                &nbsp;
                <span>{{child.name}}</span>
              </a>
            }
          </span>
        }
        @if (items.length !=  colIndex+1) {
          <mat-divider></mat-divider>
        }
      </span>
    }
  </mat-menu>